// Return best available product name/description for a given lang.
// Falls back to base (name/description) if translation is missing.
export function localizeProduct(product, lang) {
  const tr = product?.translations?.[lang];
  return {
    ...product,
    name: (tr?.name && tr.name.trim()) || product?.name || "",
    description: (tr?.description && tr.description.trim()) || product?.description || "",
  };
}
